import React from "react";
import { Button, TextField } from '@material-ui/core';
import { useField } from "react-final-form-hooks";
import UploadFile from "./UploadFile";


const UploadSingleFile = (props) => {


  const field = useField(props.name, props.form);
  const { input: { value, onChange }} = field;

  const arrValue = (Array.isArray(value) ? value : []);
  const onUpload = (imageUrls) => {
    onChange([].concat(arrValue).concat(imageUrls));
  }
  const onRemove = (index) => {
    onChange(arrValue.filter((v, i) => i !== index));
  };
  return (
    <div className="flex-row py-3 flex-wrap flex-y-start">
      <div className="flex-column flex-70p">
        <div className="flex flex-column">
          <TextField
              {...field.input}
              label={props.label}
              margin="normal"
              fullWidth
              error={field.meta.touched && field.meta.error}
              helperText={(field.meta.touched) ? field.meta.error : null}
              multiline
              variant="outlined"
              rows="6"
              size="small"
              value={arrValue.join("\n")}
              onChange={(e) => {
                onChange(e.target.value.split("\n"));
              }}
          />

          <UploadFile onChange={onUpload} accept="image/png, image/jpeg" sizeLimit={2097152} id={`file-${props.name}`}>
            <Button variant="outlined" color="primary" component="span">
              Upload New Files
            </Button>
          </UploadFile>
          <div className="my-1 small">* Support jpg, jepg, png (below 2MB)</div>
        </div>
      </div>
      <div className="flex-row flex-30p flex-wrap p2">
        {arrValue.filter(url => !!url).map((imageUrl, i) => (
          <div className="p2 width-100 text-center" key={imageUrl}>
            <div className="p1 border inline-block">
              <div className="square-5 bg-contain" style={{ backgroundImage: `url("${imageUrl}")`}} />
            </div>
            <button className="position-absolute top right border-none bg-transparent" onClick={() => onRemove(i)}>
              <i className="fa fa-times" />
            </button>
          </div>
        ))}
      </div>
      {/* <div className="p2 width-250 text-center">
        <div className="p1 border inline-block">
            <MediaGallery images={arrValue.filter(url => !!url)}/>
        </div>
      </div> */}
    </div>
  );
};

export default UploadSingleFile;
